import React, { useState, useEffect } from "react";
import { Col, Row, Table, Image, Modal, Button, Form } from "react-bootstrap";
import { SliderReusableComponent } from "../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  FormControl,
  Select,
  IconButton,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AddButtonIconComponent } from "../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";
import { ReusableOnboardingButton } from "../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { NewInputText } from "../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ToggleButtonWithYesNo } from "../../../AllButton/ToggleButtonReuse";
import { DndProvider } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import DrogDropItem from "../SeatingManagement/DrogDropItem";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  update_new_subscription_for_vendor,
  update_new_subscription_for_vendor_table_management,
} from "../../../../../../../store/actions/authAction";

import { AmealioLoader } from "../../../../../../Loader/AmealioLoader";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import { useHistory } from "react-router";
//import { QRCode } from "react-qr-svg";
import PrintComponent from "../SeatingManagement/PrintComponent";
import isEmpty from "../../../../../../../store/validation/is-Empty";

// Helper functions
function move(array, oldIndex, newIndex) {
  if (newIndex >= array.length) {
    newIndex = array.length - 1;
  }
  array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
  return array;
}

function moveElement(array, index, offset) {
  const newIndex = index + offset;

  return move(array, index, newIndex);
}

// Context

const OfflineEventTableSeatManagement = (props) => {
  //state
  const history = useHistory();
  const [activetabs, setActiveTabs] = useState(1);
  const handleTablesSeats = (v) => {
    setActiveTabs(v);
    setShowGridList(false);
  };

  const goPreviousPage = () => {
    history.push("/casual-fine-dining/seatingmanagement/table");
  };
  const [state, setState] = useState({
    floor: "1",
    section: "1",
    tableShape: "",
    tableStatus: "available",
    tableCapacity: "",
    seatCapacity: "1",
    items: [
      {
        id: "1",
        location: "Outdoor",
        seatNo: "A1",
        tableNo: "A-101",
        status: "available",
        src: require("../../../../../../../assets/images/tablemanagement/table/1-circle-available.svg"),
      },
      {
        id: "2",
        location: "Garden",
        seatNo: "A2",
        tableNo: "A-102",
        status: "dirty",
        src: require("../../../../../../../assets/images/tablemanagement/table/2-circle-onhold.svg"),
      },
      {
        id: "3",
        location: "Patio",
        seatNo: "A3",
        tableNo: "A-103",
        status: "occupied",
        src: require("../../../../../../../assets/images/tablemanagement/table/3-circle-unavailable.svg"),
      },
      {
        id: "4",
        location: "Patio",
        seatNo: "A4",
        tableNo: "A-104",
        status: "onhold",
        src: require("../../../../../../../assets/images/tablemanagement/table/4-square-occupied.svg"),
      },
      {
        id: "5",
        location: "Patio",
        seatNo: "A5",
        tableNo: "A-105",
        status: "unavailable",
        src: require("../../../../../../../assets/images/tablemanagement/table/12-rectangle-dirty.svg"),
      },
    ],
  });

  const selecthandleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const [showCreateTable, setShowCreateTable] = useState(false);
  const [showCreateSeat, setShowCreateSeat] = useState(false);
  const [showGridList, setShowGridList] = useState(false);
  const handleCreateTable = () => setShowCreateTable(true);
  const handleCloseCreateTable = () => {
    setEditTable(false);
    setTableUniqueId("");
    setShowCreateTable(false);
    formikTable.resetForm();
  };
  const handleCreateSeat = () => setShowCreateSeat(true);
  const handleCloseCreateSeat = () => {
    setEditSeat(false);
    setSeatUniqueId("");
    setShowCreateSeat(false);
    formikSeat.resetForm();
  };
  const handleGridList = () => {
    setShowGridList({
      showGridList: !showGridList.showGridList,
    });
  };

  //move function
  const setItems = (items) => setState({ ...state, items });

  const moveItem = (sourceId, destinationId) => {
    const sourceIndex = state.items.findIndex((item) => item.id === sourceId);
    const destinationIndex = state.items.findIndex(
      (item) => item.id === destinationId
    );

    // If source/destination is unknown, do nothing.
    if (sourceId === -1 || destinationId === -1) {
      return;
    }

    const offset = destinationIndex - sourceIndex;

    setState((state) => ({
      ...state,
      items: moveElement(state.items, sourceIndex, offset),
    }));
  };

  const showAlert = (msg) => {
    Alert.success(`<h4>${msg}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  const tableShape = [
    { name: "Circle", totalPax: [1, 2, 3, 4] },
    { name: "Square", totalPax: [1, 2, 3, 4] },
    { name: "Rectangle", totalPax: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  ];

  //delete table

  const [deleteTable, setDeleteTable] = useState(false);

  // delete seat

  const [deleteSeat, setDeleteSeat] = useState(false);

  const handleCloseDeleteTable = () => {
    setDeleteTable(false);
  };

  const handleCloseDeleteSeat = () => {
    setDeleteSeat(false);
  };
  const onClickYesDeleteTable = () => {
    //    allDashboardTableData
    let tempData = filteredTableDataDashboard;
    let actualTemp = allDashboardTableData;

    let filterActualTable = actualTemp.filter((table) => {
      return table.uniqueId !== tableUniqueId;
    });

    let filteredTable = tempData.filter((table) => {
      return table.uniqueId !== tableUniqueId;
    });
    setAllDashboardTableData(filterActualTable);
    setFilteredTableDataDashboard(filteredTable);
    setTableUniqueId("");
    showAlert("Table Deleted Sucessfully");
    handleCloseDeleteTable();
  };

  const onClickYesDeleteSeat = () => {
    //    allDashboardTableData
    let tempData = filteredSeatDataDashboard;
    let actualTemp = allDashboardSeatData;

    let filterActualSeat = actualTemp.filter((seat) => {
      return seat.uniqueId !== seatUniqueId;
    });

    let filteredSeat = tempData.filter((seat) => {
      return seat.uniqueId !== seatUniqueId;
    });
    setAllDashboardSeatData(filterActualSeat);
    setFilteredSeatDataDashboard(filteredSeat);
    setSeatUniqueId("");
    showAlert("Seat Deleted Sucessfully");
    handleCloseDeleteSeat();
  };

  const onClickDeleteTableIcon = (id) => {
    setTableUniqueId(id);
    setDeleteTable(true);
  };

  const onClickDeleteSeatIcon = (id) => {
    setSeatUniqueId(id);
    setDeleteSeat(true);
  };

  const [editTable, setEditTable] = useState(false);
  const [editSeat, setEditSeat] = useState(false);
  const [tableUniqueId, setTableUniqueId] = useState("");
  const [seatUniqueId, setSeatUniqueId] = useState("");
  const onClickEditTable = (tableData) => {
    let e = {};
    e.target = {};
    e.target.value = tableData.floor_number;
    onChangeFloorNumber(e);
    setTableUniqueId(tableData.uniqueId);
    setEditTable(true);
    handleCreateTable();
    formikTable.setValues(tableData);
  };

  const onClickEditSeat = (seatData) => {
    let e = {};
    e.target = {};
    e.target.value = seatData.floor_number;
    onChangeSeatNumber(e);
    setSeatUniqueId(seatData.uniqueId);
    setEditSeat(true);
    handleCreateSeat();
    formikSeat.setValues(seatData);
  };

  const [activeTableShape, setActiveTableShape] = useState([1, 2, 3, 4]);

  const onChangeTableShape = (e) => {
    let tableShpe = e.target.value;
    formikTable.setFieldValue("shape", tableShpe);
    formikTable.setFieldValue("pax_value", "");
    for (let i = 0; i < tableShape.length; i++) {
      if (tableShpe === tableShape[i].name) {
        setActiveTableShape(tableShape[i].totalPax);
        break;
      }
    }
  };

  const onChangeSelectTable = (name) => {
    formikTable.setFieldValue("location", name);
  };

  const onChangeSelectSeat = (name) => {
    formikSeat.setFieldValue("location", name);
  };

  const [tableLocation, setTableLocation] = useState([
    // {
    //   name: "Garden",
    //   icon: require("../../../../../../../assets/images/tablemanagement/Garden.svg"),
    // },
    // {
    //   name: "Patio",
    //   icon: require("../../../../../../../assets/images/tablemanagement/Patio.svg"),
    // },
    // {
    //   name: "Outdoor",
    //   icon: require("../../../../../../../assets/images/tablemanagement/Outdoor.svg"),
    // },
    // {
    //   name: "Bar",
    //   icon: require("../../../../../../../assets/images/tablemanagement/Bar.svg"),
    // },
    // {
    //   name: "Ac",
    //   icon: require("../../../../../../../assets/images/tablemanagement/Ac.svg"),
    // },
    // {
    //   name: "Non Ac",
    //   icon: require("../../../../../../../assets/images/tablemanagement/NonAC.svg"),
    // },
    // {
    //   name: "Private",
    //   icon: require("../../../../../../../assets/images/tablemanagement/Private.svg"),
    // },
  ]);

  // for table
  const [activeFloorTableDashboard, setActiveFloorTableDashboard] =
    useState("");
  const [activeAreaTableDashboard, setActiveAreaTableDashboard] = useState("");

  // for seat

  const [activeFloorSeatDashboard, setActiveFloorSeatDashboard] = useState("");
  const [activeAreaSeatDashboard, setActiveAreaSeatDashboard] = useState("");

  const onChangeDashboardTableFloorNumber = (e) => {
    let floorNo = e.target.value;
    setActiveFloorTableDashboard(floorNo);
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
  };

  const onChangeDashboardSeatFloorNumber = (e) => {
    let floorNo = e.target.value;
    setActiveFloorSeatDashboard(floorNo);

    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
  };

  const onChangeDashboardTableArea = (e) => {
    let areaNo = e.target.value;
    let filterData = [];
    setActiveAreaTableDashboard(areaNo);

    for (let i = 0; i < allDashboardTableData.length; i++) {
      if (
        allDashboardTableData[i].floor_number === activeFloorTableDashboard &&
        allDashboardTableData[i].area === areaNo
      ) {
        filterData.push(allDashboardTableData[i]);
      }
    }
    setFilteredTableDataDashboard(filterData);
  };

  const onChangeDashboardSeatArea = (e) => {
    let areaNo = e.target.value;
    let filterData = [];
    setActiveAreaSeatDashboard(areaNo);

    for (let i = 0; i < allDashboardSeatData.length; i++) {
      if (
        allDashboardSeatData[i].floor_number === activeFloorSeatDashboard &&
        allDashboardSeatData[i].area === areaNo
      ) {
        filterData.push(allDashboardSeatData[i]);
      }
    }
    setFilteredSeatDataDashboard(filterData);
  };

  const [allDashboardTableData, setAllDashboardTableData] = useState([]);

  const [allDashboardSeatData, setAllDashboardSeatData] = useState([]);

  const [filteredTableDataDashboard, setFilteredTableDataDashboard] = useState(
    []
  );

  const [filteredSeatDataDashboard, setFilteredSeatDataDashboard] = useState(
    []
  );

  const [uniqueFloorData, setUniqueFloorData] = useState([]);
  const [activeSectionData, setActiveSectionData] = useState([]);
  const onChangeFloorNumber = (e) => {
    let floorNo = e.target.value;
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
    formikTable.setFieldValue("floor_number", floorNo);
    formikTable.setFieldValue("area", "");
  };

  const onChangeSeatNumber = (e) => {
    let floorNo = e.target.value;
    //let activeData=[]
    for (let i = 0; i < uniqueFloorData.length; i++) {
      if (uniqueFloorData[i].name === floorNo) {
        setActiveSectionData(uniqueFloorData[i].items);
        break;
      }
    }
    formikSeat.setFieldValue("floor_number", floorNo);
    formikSeat.setFieldValue("area", "");
  };

  const onChangeFloorArea = (e) => {
    formikTable.setFieldValue("area", e.target.value);
  };

  const onChangeSeatArea = (e) => {
    formikSeat.setFieldValue("area", e.target.value);
  };
  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };
  //const [selectedTable, setSelectedTable] = useState("");

  const onChangeTableTemporary = () => {
    formikTable.setFieldValue("temporay", !formikTable.values.temporay);
  };

  const onChangeSeatTemporary = () => {
    formikSeat.setFieldValue("temporay", !formikSeat.values.temporay);
  };
  const onChangeTableActiveInActive = () => {
    if (!formikTable.values.active === false) {
      formikTable.setFieldValue("status", "UNAVAILABLE");
      formikTable.setFieldValue("active", !formikTable.values.active);
    } else {
      formikTable.setFieldValue("active", !formikTable.values.active);
      formikTable.setFieldValue("status", "AVAILABLE");
    }
  };

  const onChangeSeatActiveInActive = () => {
    if (!formikSeat.values.active === false) {
      formikSeat.setFieldValue("status", "UNAVAILABLE");
      formikSeat.setFieldValue("active", !formikSeat.values.active);
    } else {
      formikSeat.setFieldValue("active", !formikSeat.values.active);
      formikSeat.setFieldValue("status", "AVAILABLE");
    }
  };

  const onCLickAddNewTable = () => {
    formikTable.handleSubmit();
  };
  const [qrTableData, setQrTableData] = useState([]);
  const [typeOfQr, setTypeOfQr] = useState("");

  const onSuccessShowQr = (tableWithoutId, tablesWithId, type) => {
    if (type === "table") {
      let dataForQr = [];
      setTypeOfQr("table");
      let tablesWithIdTable =
        tablesWithId?.casual_dining_status?.seating?.table_management
          ?.table_setup?.table;

      for (let i = 0; i < tableWithoutId.length; i++) {
        for (let j = 0; j < tablesWithIdTable.length; j++) {
          if (
            tableWithoutId[i].table_number ===
              tablesWithIdTable[j].table_number &&
            tableWithoutId[i].area === tablesWithIdTable[j].area
          ) {
            dataForQr.push(tablesWithIdTable[j]);
          }
        }
      }
      setAllDashboardTableData(tablesWithIdTable);
      setFilteredTableDataDashboard(tablesWithIdTable);
      setQrTableData(dataForQr);
      handleCloseCreateTable();
      setConfirmAddTablePrint(true);
      formikTable.resetForm();
    } else {
      let dataForQr = [];

      setTypeOfQr("seat");
      let tablesWithIdTable =
        tablesWithId?.casual_dining_status?.seating?.table_management
          ?.table_setup?.seat;

      for (let i = 0; i < tableWithoutId.length; i++) {
        for (let j = 0; j < tablesWithIdTable.length; j++) {
          if (
            tableWithoutId[i].seat_number ===
              tablesWithIdTable[j].seat_number &&
            tableWithoutId[i].area === tablesWithIdTable[j].area
          ) {
            dataForQr.push(tablesWithIdTable[j]);
          }
        }
      }
      setAllDashboardSeatData(tablesWithIdTable);
      setFilteredSeatDataDashboard(tablesWithIdTable);
      setQrTableData(dataForQr);
      handleCloseCreateSeat();
      setConfirmAddTablePrint(true);
      formikSeat.resetForm();
    }
  };

  const formikTable = useFormik({
    initialValues: {
      floor_number: "",
      area: "",
      table_number: "",
      shape: "Circle",
      pax_value: "",
      temporay: false,
      active: true,
      location: "",
      status: "AVAILABLE",
      number: "",
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please select floor number "),
      area: yup.string().required("Please select area/section "),
      // table_number: yup.string().required("Please enter table number"),
      pax_value: yup.string().required("Please select total capacity"),
      location: yup.string().required("Please select table location "),
      number: yup.string().required("Please enter numer of tables "),
    }),

    onSubmit: (values) => {
      if (!editTable) {
        // for new data
        let table = [];
        let existingTableData = allDashboardTableData;
        let newAn = existingTableData.filter((ele) =>
          ele.table_number.includes(
            formikTable.values.table_number === ""
              ? `${values.table_number} `
              : `${values.table_number}-`
          )
        );
        let inc = 0;
        if (!isEmpty(newAn)) {
          let lastNum = newAn[newAn.length - 1];
          lastNum = lastNum.table_number.split(
            formikTable.values.table_number === "" ? " " : "-"
          );
          inc = parseInt(lastNum[lastNum.length - 1]);
        }
        for (let i = 0; i < values.number; i++) {
          let increment_number = inc + i + 1;
          let dataValue = formikTable.values.table_number === "" ? " " : "-";
          let incrementTableNumber =
            values.table_number + dataValue + increment_number;
          let generateUniqueId =
            allDashboardTableData.length + increment_number;
          table.push({
            ...values,
            table_number: incrementTableNumber,
            uniqueId: generateUniqueId,
          });
        }
        let formData = [...existingTableData, ...table];
        // setAllDashboardTableData(formData);
        // setFilteredTableDataDashboard(formData);

        // qr code changes

        const formData1 = { ...props.allSubscriptionData };

        formData1.casual_dining_status.seating.table_management.table_setup.table =
          formData;

        const token = props?.auth?.user?.accessToken;
        const subscriptionId = props?.subscription?._id;
        props.update_new_subscription_for_vendor_table_management(
          subscriptionId,
          formData1,
          token,
          onSuccessShowQr,
          table,
          "table"
        );
        //
      } else {
        let filteredData = filteredTableDataDashboard;
        let actualAllTableData = allDashboardTableData;
        let updatedFilteredData = [];
        let updatedActualData = [];

        // this loop is for setting data for what we see on filtered screen
        for (let i = 0; i < filteredData.length; i++) {
          if (
            filteredData[i].uniqueId === tableUniqueId &&
            filteredData[i].floor_number === values.floor_number &&
            filteredData[i].area === values.area
          ) {
            updatedFilteredData.push(values);
          } else if (filteredData[i].uniqueId === tableUniqueId) {
            // dont append as user changed floor / area
          } else {
            updatedFilteredData.push(filteredData[i]);
          }
        }
        for (let i = 0; i < actualAllTableData.length; i++) {
          if (actualAllTableData[i].uniqueId === tableUniqueId) {
            updatedActualData.push(values);
          } else {
            updatedActualData.push(actualAllTableData[i]);
          }
        }
        if (
          activeFloorTableDashboard === "" &&
          activeAreaTableDashboard === ""
        ) {
          setFilteredTableDataDashboard(updatedActualData);
        } else {
          setFilteredTableDataDashboard(updatedFilteredData);
        }
        setAllDashboardTableData(updatedActualData);
        setTableUniqueId("");
        showAlert("Table Edited Sucessfully");
        console.log(updatedActualData);
        handleCloseCreateTable();
        //setConfirmAddTablePrint(true);
        formikTable.resetForm();
      }
    },
  });

  const onCLickAddNewSeat = () => {
    formikSeat.handleSubmit();
  };

  const formikSeat = useFormik({
    initialValues: {
      floor_number: "",
      area: "",
      seat_number: "",
      shape: "Square",
      pax_value: "1",
      temporay: false,
      active: true,
      location: "",
      status: "AVAILABLE",
      number: "",
    },
    validationSchema: yup.object({
      floor_number: yup.string().required("Please select floor number "),
      area: yup.string().required("Please select area/section "),
      // seat_number: yup.string().required("Please enter seat name/ number"),
      //pax_value: yup.string().required("Please enter total capacity"),
      location: yup.string().required("Please select seat location "),
      number: yup.string().required("Please enter numer of seats "),
    }),

    onSubmit: (values) => {
      if (!editSeat) {
        // for new data
        let seat = [];
        let existingTableData = allDashboardSeatData;

        for (let i = 0; i < values.number; i++) {
          let increment_number = i + 1;
          let dataValue = formikSeat?.values?.seat_number === "" ? " " : "-";
          let incrementTableNumber =
            values.seat_number + dataValue + increment_number;
          let generateUniqueId = allDashboardSeatData.length + increment_number;
          seat.push({
            ...values,
            seat_number: incrementTableNumber,
            uniqueId: generateUniqueId,
          });
        }
        let formData = [...existingTableData, ...seat];
        // setAllDashboardSeatData(formData);
        // setFilteredSeatDataDashboard(formData);
        const formData1 = { ...props.allSubscriptionData };

        //formData.casual_dining_status.seating.table_management.value = true;
        formData1.casual_dining_status.seating.table_management.table_setup.seat =
          formData;

        const token = props?.auth?.user?.accessToken;
        const subscriptionId = props?.subscription?._id;
        props.update_new_subscription_for_vendor_table_management(
          subscriptionId,
          formData1,
          token,
          onSuccessShowQr,
          seat,
          "seat"
        );
      } else {
        let filteredData = filteredSeatDataDashboard;
        let actualAllSeatData = allDashboardSeatData;
        let updatedFilteredData = [];
        let updatedActualData = [];

        // this loop is for setting data for what we see on filtered screen
        for (let i = 0; i < filteredData.length; i++) {
          if (
            filteredData[i].uniqueId === seatUniqueId &&
            filteredData[i].floor_number === values.floor_number &&
            filteredData[i].area === values.area
          ) {
            updatedFilteredData.push(values);
          } else if (filteredData[i].uniqueId === seatUniqueId) {
            // dont append as user changed floor / area
          } else {
            updatedFilteredData.push(filteredData[i]);
          }
        }
        for (let i = 0; i < actualAllSeatData.length; i++) {
          if (actualAllSeatData[i].uniqueId === seatUniqueId) {
            updatedActualData.push(values);
          } else {
            updatedActualData.push(actualAllSeatData[i]);
          }
        }
        if (activeFloorSeatDashboard === "" && activeAreaSeatDashboard === "") {
          setFilteredSeatDataDashboard(updatedActualData);
        } else {
          setFilteredSeatDataDashboard(updatedFilteredData);
        }
        setAllDashboardSeatData(updatedActualData);
        setSeatUniqueId("");
        showAlert("Seat Edited Sucessfully");
        handleCloseCreateSeat();
        formikSeat.resetForm();
      }

      // handleCloseCreateSeat();
      // formikSeat.resetForm();
    },
  });

  const onClickDone = () => {
    if (
      allDashboardTableData.length === 0 &&
      allDashboardSeatData.length === 0
    ) {
      Alert.error(`<h4>Please  setup atleast one table or seat</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const formData = props?.allSubscriptionData;

      formData.casual_dining_status.seating.table_management.value = true;
      formData.casual_dining_status.seating.table_management.table_setup.table =
        allDashboardTableData;
      formData.casual_dining_status.seating.table_management.table_setup.seat =
        allDashboardSeatData;
      //formData.casual_dining_status.seating.table_management.table_setup = values;

      const token = props?.auth?.user?.accessToken;
      const subscriptionId = props?.subscription?._id;
      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        onSuccess
      );
    }
  };
  const onSuccess = (e) => {
    Alert.success(
      activetabs === 1
        ? `<h4>Table setup Successfully</h4>`
        : `<h4>Seat setup Successfully</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
    history.push("/casual-fine-dining/seatingmanagement");
  };

  useEffect(() => {
    let data = props?.allSubscriptionData;

    if (
      data &&
      data?.casual_dining_status &&
      data?.casual_dining_status?.seating &&
      data?.casual_dining_status?.seating?.table_management?.table_setup
    ) {
      let setDropDownDataForTable =
        data?.casual_dining_status?.seating?.table_management?.table_setup
          ?.floors;
      // set unique id to each recond locally

      // for table starts
      let asiignIdToEachRecord = []; // help us to delete or edit record

      let apiTableData =
        data?.casual_dining_status?.seating?.table_management?.table_setup
          ?.table;

      for (let i = 0; i < apiTableData.length; i++) {
        let incrementId = i + 1;
        let data = apiTableData[i];
        data.uniqueId = incrementId;
        asiignIdToEachRecord.push(data);
      }

      setAllDashboardTableData(asiignIdToEachRecord); // this is our main reference
      setFilteredTableDataDashboard(asiignIdToEachRecord);

      //// for table ends

      // for seat starts
      let asiignIdToEachRecordSeat = []; // help us to delete or edit record

      let apiSeatData =
        data?.casual_dining_status?.seating?.table_management?.table_setup
          ?.seat;

      for (let i = 0; i < apiSeatData.length; i++) {
        let incrementId = i + 1;
        let data = apiSeatData[i];
        data.uniqueId = incrementId;
        asiignIdToEachRecordSeat.push(data);
      }

      setAllDashboardSeatData(asiignIdToEachRecordSeat); // this is our main reference
      setFilteredSeatDataDashboard(asiignIdToEachRecordSeat);

      //// for seat ends

      //
      let uniqueFloors = [];
      for (let i = 0; i < setDropDownDataForTable.length; i++) {
        if (!uniqueFloors.includes(setDropDownDataForTable[i].floor_number)) {
          uniqueFloors.push(setDropDownDataForTable[i].floor_number);
        }
      }

      let structuredData = [];
      for (let i = 0; i < uniqueFloors.length; i++) {
        structuredData.push({ name: uniqueFloors[i], items: [] });
      }
      let finalStructuredData = structuredData;
      for (let i = 0; i < setDropDownDataForTable.length; i++) {
        for (let j = 0; j < structuredData.length; j++) {
          if (
            structuredData[j].name === setDropDownDataForTable[i].floor_number
          ) {
            finalStructuredData[j].items.push(setDropDownDataForTable[i].area);
          }
        }
      }

      setUniqueFloorData(finalStructuredData);

      let selectedSeating =
        data?.casual_dining_status?.seating?.general_seating?.seating_areas;
      let seatingSelected = [];

      for (let i = 0; i < props?.seating_area.length; i++) {
        if (selectedSeating.includes(props?.seating_area[i]?._id)) {
          seatingSelected.push(props?.seating_area[i]);
        }
      }
      setTableLocation(seatingSelected);
    }
  }, [props?.allSubscriptionData, props?.seating_area]);

  const [confirmAddTablePrint, setConfirmAddTablePrint] = useState(false);
  const [openPrintPreview, setOpenPrintPreview] = useState(false);

  const printQrCodeAction = () => {
    // const printableElements = document.getElementById("printme").innerHTML;
    // const orderHtml =
    //   "<html><head><title></title></head><body>" +
    //   printableElements +
    //   "</body></html>";
    // const oldPage = document.body.innerHTML;
    // document.body.innerHTML = orderHtml;
    window.print();
    // window.location.reload();
    // document.body.innerHTML = oldPage;
    // setOpenPrintPreview(false);
    // setOpenPrintPreview(true);
  };
  return (
    <React.Fragment>
      {props?.auth?.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      displayArrow={true}
                      backButtonClicked={
                        "/casual-fine-dining/seatingmanagement/table"
                      }
                    />
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <MobileTopHeader
                    link={true}
                    onLink={"/casual-fine-dining/seatingmanagement/table"}
                  />
                </Media>

                <div className="onboarding_process_screen-button-map">
                  <div className="pb-4">
                    <TopTextReusableComponent headingText="Table/Seat Management" />
                  </div>
                  <div className="d-flex align-items-center pb-5">
                    <button
                      type="button"
                      className={`enTabsBtn ${
                        activetabs === 1 ? "active" : ""
                      }`}
                      onClick={() => handleTablesSeats(1)}
                    >
                      Create Tables
                    </button>
                    <button
                      type="button"
                      className={`enTabsBtn ${
                        activetabs === 2 ? "active" : ""
                      }`}
                      onClick={() => handleTablesSeats(2)}
                    >
                      Create Seats
                    </button>
                  </div>
                  {activetabs === 1 && (
                    <React.Fragment>
                      <Row>
                        <Col md={5}>
                          <FormControl variant="outlined" className={"w-100"}>
                            <Select
                              value={activeFloorTableDashboard}
                              onChange={onChangeDashboardTableFloorNumber}
                              inputProps={{
                                name: "floor",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {uniqueFloorData.map((item, index) => (
                                <MenuItem key={index} value={item.name}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <div className="f10-400 opacity5">
                            (Select Floor from Above)
                          </div>
                        </Col>
                        <Col md={3}>
                          <FormControl variant="outlined" className={"w-100"}>
                            <Select
                              value={activeAreaTableDashboard}
                              onChange={onChangeDashboardTableArea}
                              inputProps={{
                                name: "section",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {activeSectionData.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <div className="f10-400 opacity5">
                            (Select Section on this Floor)
                          </div>
                        </Col>
                      </Row>
                      <Row className="py-4">
                        <Col md={6}>
                          <div className="f14-500">Table Arrangement</div>
                        </Col>
                        <Col md={6}>
                          <Row className="justify-content-between">
                            <Col>
                              <AddButtonIconComponent
                                buttonText="Add Tables"
                                fontIcon="fa fa-plus"
                                colorCss="red"
                                onClick={handleCreateTable}
                              />
                            </Col>
                            {/* <Col className="d-flex justify-content-end">
                              <button
                                type="button"
                                className={
                                  "add-button-icon-reusable add-button-icon-reusable-blue"
                                }
                                onClick={handleGridList}
                              >
                                Grid view
                              </button>
                            </Col> */}
                          </Row>
                        </Col>
                      </Row>
                      {showGridList.showGridList ? (
                        <React.Fragment>
                          <Scrollbars
                            style={{
                              width: "100%",
                              height: 450,
                              border: "1px solid #dee2e6",
                            }}
                          >
                            <div className="p-4">
                              <DndProvider backend={HTML5Backend}>
                                <DrogDropItem
                                  displayTable={true}
                                  value={state.items}
                                  moveItem={moveItem}
                                />
                              </DndProvider>
                            </div>
                          </Scrollbars>
                          <div className="f16-500">Drag and Move</div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Scrollbars
                            style={{
                              width: "100%",
                              height: 400,
                              border: "1px solid #dee2e6",
                              borderRadius: 11,
                            }}
                          >
                            <div className="enTableArrangement table-responsive">
                              <Table className="w-100">
                                <thead>
                                  <tr>
                                    <th className="f12-700">Floor</th>
                                    <th className="f12-700">Section</th>
                                    <th className="f12-700">No.</th>
                                    <th className="f12-700">Shape</th>
                                    <th className="f12-700">Capacity</th>
                                    <th className="f12-700">Location</th>
                                    <th className="f12-700">Status</th>
                                    <th className="f12-700">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredTableDataDashboard.map(
                                    (item, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="f12-400">
                                            {item.floor_number}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {item.area}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {item.table_number}
                                          </div>
                                        </td>
                                        <td>
                                          {item.shape === "Square" ? (
                                            <Image
                                              src={require("../../../../../../../assets/images/UserManagement/square.svg")}
                                              alt="square"
                                              title="square"
                                              width="33px"
                                              height="19px"
                                            />
                                          ) : (
                                            <> </>
                                          )}

                                          {item.shape === "Rectangle" ? (
                                            <Image
                                              src={require("../../../../../../../assets/images/UserManagement/rectangle.svg")}
                                              alt="Rectangle"
                                              title="Rectangle"
                                              width="33px"
                                              height="19px"
                                            />
                                          ) : (
                                            <> </>
                                          )}

                                          {item.shape === "Circle" ? (
                                            <Image
                                              src={require("../../../../../../../assets/images/UserManagement/circle.svg")}
                                              alt="Circle"
                                              title="Circle"
                                              width="33px"
                                              height="19px"
                                            />
                                          ) : (
                                            <> </>
                                          )}
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {" "}
                                            {item.pax_value}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {item.location}
                                          </div>
                                        </td>
                                        <td>
                                          <span
                                            className={` ${
                                              item.status === "AVAILABLE"
                                                ? "enGreenDot"
                                                : item.status === "UNAVAILABLE"
                                                ? "enGreyDot"
                                                : item.status === "OCCUPIED"
                                                ? "enRedDot"
                                                : item.status === "ON_HOLD"
                                                ? "enYellowDot"
                                                : "enBrownDot"
                                            }`}
                                          ></span>
                                        </td>
                                        <td>
                                          <div className="d-flex">
                                            <IconButton className="mr-2 p-0">
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                                alt="edit table"
                                                title="edit table"
                                                className="w-20px"
                                                onClick={() =>
                                                  onClickEditTable(item)
                                                }
                                              />
                                            </IconButton>
                                            <IconButton className="mr-2 p-0">
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                                alt="delete table"
                                                title="delete table"
                                                className="w-20px"
                                                onClick={() =>
                                                  onClickDeleteTableIcon(
                                                    item.uniqueId
                                                  )
                                                }
                                              />
                                            </IconButton>
                                            <IconButton className="p-0">
                                              <Image
                                                src={require("../../../../../../../assets/images/tablemanagement/print_black.svg")}
                                                alt="print table"
                                                title="Print QR Code"
                                                className="w-20px"
                                                // onClick={() =>
                                                //   onClickDeleteTableIcon(
                                                //     item.uniqueId
                                                //   )
                                                // }
                                                onClick={() => {
                                                  setTypeOfQr("table");
                                                  setQrTableData([item]);
                                                  setConfirmAddTablePrint(true);
                                                }}
                                              />
                                            </IconButton>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Scrollbars>
                        </React.Fragment>
                      )}
                      <div className="onboarding-map-setup-screen-autodetect-button pt-5">
                        <ReusableOnboardingButton
                          buttonTitle="Back"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          buttonType="button"
                          onClick={() => goPreviousPage()}
                        />
                        <ReusableOnboardingButton
                          buttonTitle="Done"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                          buttonText="Done"
                          buttonType="button"
                          onClick={() => onClickDone()}
                        />
                      </div>
                    </React.Fragment>
                  )}
                  {activetabs === 2 && (
                    <React.Fragment>
                      <Row>
                        <Col md={5}>
                          <FormControl variant="outlined" className={"w-100"}>
                            <Select
                              value={activeFloorSeatDashboard}
                              onChange={onChangeDashboardSeatFloorNumber}
                              inputProps={{
                                name: "floor",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {uniqueFloorData.map((item, index) => (
                                <MenuItem key={index} value={item.name}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <div className="f10-400 opacity5">
                            (Select Floor from Above)
                          </div>
                        </Col>
                        <Col md={3}>
                          <FormControl variant="outlined" className={"w-100"}>
                            <Select
                              value={activeAreaSeatDashboard}
                              onChange={onChangeDashboardSeatArea}
                              inputProps={{
                                name: "section",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {activeSectionData.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <div className="f10-400 opacity5">
                            (Select Section on this Floor)
                          </div>
                        </Col>
                      </Row>
                      <Row className="py-4">
                        <Col md={6}>
                          <div className="f14-500">Seat Arrangement</div>
                        </Col>
                        <Col md={6}>
                          <Row className="justify-content-between">
                            <Col>
                              <AddButtonIconComponent
                                buttonText="Add Seats"
                                fontIcon="fa fa-plus"
                                colorCss="red"
                                onClick={handleCreateSeat}
                              />
                            </Col>
                            {/* <Col className="d-flex justify-content-end">
                              <button
                                type="button"
                                className={
                                  "add-button-icon-reusable add-button-icon-reusable-blue"
                                }
                                onClick={handleGridList}
                              >
                                Grid view
                              </button>
                            </Col> */}
                          </Row>
                        </Col>
                      </Row>
                      {showGridList.showGridList ? (
                        <React.Fragment>
                          <Scrollbars
                            style={{
                              width: "100%",
                              height: 450,
                              border: "1px solid #dee2e6",
                            }}
                          >
                            {/* <div className="d-flex align-items-center p-2">
                          <div className="enSeat occupied">A1</div>
                          <div className="enSeat available">A2</div>
                          <div className="enSeat dirty">A3</div>
                          <div className="enSeat onhold">A4</div>
                          <div className="enSeat unavailable">A5</div>
                        </div> */}
                            <div className="d-flex align-items-center p-2">
                              <DndProvider backend={HTML5Backend}>
                                <DrogDropItem
                                  value={state.items}
                                  moveItem={moveItem}
                                />
                              </DndProvider>
                            </div>
                          </Scrollbars>
                          <div className="f16-500">Drag and Move</div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Scrollbars
                            style={{
                              width: "100%",
                              height: 400,
                              border: "1px solid #dee2e6",
                              borderRadius: 11,
                            }}
                          >
                            <div className="enTableArrangement table-responsive">
                              <Table className="w-100">
                                <thead>
                                  <tr>
                                    <th className="f12-700">Floor</th>
                                    <th className="f12-700">Section</th>
                                    <th className="f12-700">Seat</th>
                                    <th className="f12-700">Shape</th>
                                    <th className="f12-700">Capacity</th>
                                    <th className="f12-700">Location</th>
                                    <th className="f12-700">Status</th>
                                    <th className="f12-700">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredSeatDataDashboard.map(
                                    (item, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div className="f12-400">
                                            {item.floor_number}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {item.area}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {item.seat_number}
                                          </div>
                                        </td>
                                        <td>
                                          <Image
                                            src={require("../../../../../../../assets/images/tablemanagement/seat1.svg")}
                                            alt="add"
                                            title="add"
                                            width="33px"
                                            height="33px"
                                          />
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {" "}
                                            {item.pax_value}
                                          </div>
                                        </td>
                                        <td>
                                          <div className="f12-400">
                                            {" "}
                                            {item.location}
                                          </div>
                                        </td>
                                        <td>
                                          <span
                                            className={` ${
                                              item.status === "AVAILABLE"
                                                ? "enGreenDot"
                                                : item.status === "UNAVAILABLE"
                                                ? "enGreyDot"
                                                : item.status === "OCCUPIED"
                                                ? "enRedDot"
                                                : item.status === "ON_HOLD"
                                                ? "enYellowDot"
                                                : "enBrownDot"
                                            }`}
                                          ></span>
                                        </td>
                                        <td>
                                          <div className="d-flex">
                                            <IconButton className="mr-2 p-0">
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                                alt="edit seat"
                                                title="edit seat"
                                                className="w-20px"
                                                onClick={() =>
                                                  onClickEditSeat(item)
                                                }
                                              />
                                            </IconButton>
                                            <IconButton className="mr-2 p-0">
                                              <Image
                                                src={require("../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                                alt="delete seat"
                                                title="delete seat"
                                                className="w-20px"
                                                onClick={() =>
                                                  onClickDeleteSeatIcon(
                                                    item.uniqueId
                                                  )
                                                }
                                              />
                                            </IconButton>
                                            <IconButton className="p-0">
                                              <Image
                                                src={require("../../../../../../../assets/images/tablemanagement/print_black.svg")}
                                                alt="print table"
                                                title="print table"
                                                className="w-20px"
                                                onClick={() => {
                                                  setTypeOfQr("seat");
                                                  setQrTableData([item]);
                                                  setConfirmAddTablePrint(true);
                                                }}
                                              />
                                            </IconButton>
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Scrollbars>
                        </React.Fragment>
                      )}
                      <div className="onboarding-map-setup-screen-autodetect-button pt-5">
                        <ReusableOnboardingButton
                          buttonTitle="Back"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                          buttonText="Back"
                          buttonType="button"
                          onClick={() => goPreviousPage()}
                        />
                        <ReusableOnboardingButton
                          buttonTitle="Done"
                          buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                          buttonText="Done"
                          buttonType="button"
                          onClick={() => onClickDone()}
                        />
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={true}
                  displayHamburger={true}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-06.svg")}
                />
              </div>
            </div>
          </div>
          <Modal
            show={openPrintPreview}
            onHide={() => {
              setOpenPrintPreview(false);
            }}
            size="lg"
            centered
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  Print Preview
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              {/* <div
                id="printme divtoprint"
                style={{
                  boxShadow: "0px 3px 6px #00000029",
                }}
                className="d-flex justify-content-center "
              >
                <div className="QRMain-onboarding" align="center">
                  <div className="QRInner-onboarding p-4">
                    <div>
                      <Image
                        fluid
                        src={props.onboarding && props.onboarding.logo_url}
                        alt="Logo"
                        style={{ width: "25%" }}
                      />
                    </div>
                    <div className="print-12-500-r text-uppercase f12-500">
                      <span className="">
                        {props.onboarding && props.onboarding.restaurant_name}
                      </span>
                    </div>
                    <div className="qrPript">
                      <QRCode
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="H"
                        style={{ width: "170px", heght: 77 }}
                        value={props.onboarding.vendor_id}
                      />
                    </div>
                    <div className="f12-500">Table Number - A-101</div>

                    <hr />
                    <div className="print-12-400-h">
                      Scan in amealio App for
                    </div>
                    <div className="">
                      <Image
                        fluid
                        src={require("../../../../../../../assets/images/UserManagement/fullLogo.svg")}
                        alt="Logo"
                        style={{ width: "25%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>*/}
              <PrintComponent
                onboarding={props?.onboarding}
                setOpenPrintPreview={setOpenPrintPreview}
                qrData={qrTableData}
                typeOfQr={typeOfQr}
              />
            </Modal.Body>
          </Modal>
          <Modal
            show={confirmAddTablePrint}
            onHide={() => {
              setConfirmAddTablePrint(false);
            }}
            centered
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  Print QR code
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              <div className="f12-500">
                Do you want to print QR code for this Seat/Table?
              </div>
              <div className="d-flex justify-content-center align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn-md mr-4 px-5"
                  onClick={() => {
                    setConfirmAddTablePrint(false);
                  }}
                >
                  Print Later
                </Button>
                <Button
                  variant="danger"
                  type="button"
                  onClick={() => {
                    setOpenPrintPreview(true);
                    setConfirmAddTablePrint(false);
                  }}
                  className="btn-md px-5"
                >
                  Print
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={showCreateTable}
            onHide={handleCloseCreateTable}
            centered
          >
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  {editTable ? "Edit" : "Create"} a Table
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              <Form>
                <Row>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Floor Number /Name
                      </InputLabel>
                      <Select
                        value={formikTable.values.floor_number}
                        onChange={onChangeFloorNumber}
                        label="Section Number /Name"
                        inputProps={{
                          name: "floor",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {uniqueFloorData.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikTable.errors.floor_number &&
                      formikTable.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikTable.errors.floor_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Section Number /Name
                      </InputLabel>
                      <Select
                        value={formikTable.values.area}
                        onChange={onChangeFloorArea}
                        label="Section Number /Name"
                        inputProps={{
                          name: "section",
                          id: "outlined-section",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeSectionData.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikTable.errors.area && formikTable.touched.area ? (
                        <div className="pho_14_regular text-danger">
                          {formikTable.errors.area}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <NewInputText
                      labelText="Table Number /Name"
                      extraClass={`mb-3 w-100 ${
                        formikTable.errors.table_number &&
                        formikTable.touched.table_number
                          ? "enError"
                          : ""
                      }`}
                      inputType="text"
                      name="table_number"
                      onChange={formikTable.handleChange}
                      value={formikTable.values.table_number}
                      onFocusOut={formikTable.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    {formikTable.errors.table_number &&
                    formikTable.touched.table_number ? (
                      <div className="pho_14_regular text-danger mb-2">
                        {formikTable.errors.table_number}
                      </div>
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </Col>
                  {/* <Col md={6}>
                <NewInputText
                  labelText="Table Capacity"
                  extraClass="mb-3 w-100"
                />
                <span className="f14-400 opacity5 enPositionRightTop">pax</span>
              </Col> */}
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-tableShape">
                        Table Shape
                      </InputLabel>
                      <Select
                        value={formikTable.values.shape}
                        //onChange={selecthandleChange}
                        onChange={onChangeTableShape}
                        name
                        label="Table Shape"
                        inputProps={{
                          name: "shape",
                          id: "outlined-tableShape",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"Circle"}>Circle &#9675;</MenuItem>
                        <MenuItem value={"Rectangle"}>
                          Rectangle &#9645;
                        </MenuItem>
                        <MenuItem value={"Square"}>Square &#9744;</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormControl variant="outlined" className={"w-100 mb-0"}>
                      <InputLabel htmlFor="outlined-tableCapacity">
                        Table Capacity
                      </InputLabel>
                      <Select
                        //value={state.tableCapacity}
                        value={formikTable.values.pax_value}
                        //onChange={selecthandleChange}
                        onChange={formikTable.handleChange}
                        label="Table Capacity"
                        inputProps={{
                          name: "pax_value",
                          id: "outlined-tableCapacity",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeTableShape.map((pax, index) => (
                          <MenuItem key={index} value={pax}>
                            {pax}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <div className="f10-400 opacity5">Total PAX</div>
                    {formikTable.errors.pax_value &&
                    formikTable.touched.pax_value ? (
                      <div className="pho_14_regular text-danger">
                        {formikTable.errors.pax_value}
                      </div>
                    ) : null}
                  </Col>

                  <Col md={6}>
                    <div className="d-flex">
                      <div className="custom">
                        <div className="f10-400 pb-2 opacity5">
                          Temporary Table
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikTable.values.temporay}
                          onChange={() => onChangeTableTemporary()}
                          className={"mx-1"}
                        />
                      </div>
                      <div className="pl-3 custom">
                        <div className="f10-400 pb-2 opacity5">
                          Active/ Inactive
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikTable.values.active}
                          onChange={() => onChangeTableActiveInActive()}
                          className={"mx-1"}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f12-400">Select Table Location</div>
                    <div className="f10-400 opacity5 pb-3">
                      (Locations are based on the seating areas you have
                      selected in seating subscription)
                    </div>
                  </Col>
                  {tableLocation.map((item, index) => (
                    <Col md={4} xs={6} key={index}>
                      <div className="enCheckWithText w-100">
                        <input
                          type="radio"
                          name="SeatingPreference"
                          checked={formikTable.values.location === item.title}
                          onChange={() => onChangeSelectTable(item.title)}
                        />
                        <label
                          className="w-100 d-flex align-items-center p-2"
                          style={{ fontSize: 11 }}
                        >
                          <Image
                            src={item.icon}
                            alt={item.title}
                            title={item.title}
                            className="mr-2"
                            style={{ width: "20%" }}
                          />
                          {item.title}
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
                {formikTable.errors.location && formikTable.touched.location ? (
                  <div className="pho_14_regular text-danger">
                    {formikTable.errors.location}
                  </div>
                ) : null}
                <Row className="align-items-center py-3">
                  <Col md={6}>
                    <div className="f12-400">Table Status</div>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100"}>
                      <Select
                        //value={state.tableStatus}
                        value={formikTable.values.status}
                        disabled={!formikTable.values.active}
                        //onChange={selecthandleChange}
                        onChange={formikTable.handleChange}
                        inputProps={{
                          name: "status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"AVAILABLE"}>Available</MenuItem>
                        <MenuItem value={"UNAVAILABLE"}>Unavailable</MenuItem>
                        <MenuItem value={"OCCUPIED"}>Occupied</MenuItem>
                        <MenuItem value={"DIRTY"}>Dirty</MenuItem>
                        <MenuItem value={"ON_HOLD"}>On Hold</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                {!editTable ? (
                  <Row className="align-items-center py-3">
                    <Col md={6}>
                      <div className="f12-400">How many Tables to Create?</div>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col>
                          <NewInputText
                            extraClass={`m-1 w-100 ${
                              formikTable.errors.number &&
                              formikTable.touched.number
                                ? "enError"
                                : ""
                            }`}
                            inputType="number"
                            onInput={maxLengthCheck}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            maxLength={2}
                            name="number"
                            onChange={formikTable.handleChange}
                            value={formikTable.values.number}
                            onFocusOut={formikTable.handleBlur}
                            // isInvalid={
                            //   formik.errors.bankName && formik.touched.bankName
                            // }
                          />
                          {formikTable.errors.number &&
                          formikTable.touched.number ? (
                            <div className="pho_14_regular text-danger">
                              {formikTable.errors.number}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <> </>
                )}
                <div className="d-flex justify-content-center align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseCreateTable}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    type="button"
                    onClick={() => onCLickAddNewTable()}
                    className="btn150px btn-lg px-5"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>
          <Modal show={showCreateSeat} onHide={handleCloseCreateSeat} centered>
            <Modal.Header className="px-4 border-0" closeButton>
              <div>
                <Modal.Title className="f20-700 pb-2">
                  {editSeat ? "Edit" : "Create"} a Seat
                </Modal.Title>
              </div>
            </Modal.Header>
            <Modal.Body className="px-4 new-subscription-onboarding-component">
              <Form>
                <Row>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Floor Number /Name
                      </InputLabel>
                      <Select
                        value={formikSeat.values.floor_number}
                        onChange={onChangeSeatNumber}
                        label="Section Number /Name"
                        inputProps={{
                          name: "floor",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {uniqueFloorData.map((item, index) => (
                          <MenuItem key={index} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikSeat.errors.floor_number &&
                      formikSeat.touched.floor_number ? (
                        <div className="pho_14_regular text-danger">
                          {formikSeat.errors.floor_number}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-section">
                        Section Number /Name
                      </InputLabel>
                      <Select
                        value={formikSeat.values.area}
                        onChange={onChangeSeatArea}
                        label="Section Number /Name"
                        inputProps={{
                          name: "section",
                          id: "outlined-section",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        {activeSectionData.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                      {formikSeat.errors.area && formikSeat.touched.area ? (
                        <div className="pho_14_regular text-danger">
                          {formikSeat.errors.area}
                        </div>
                      ) : null}
                    </FormControl>
                  </Col>
                  <Col md={6}>
                    <NewInputText
                      labelText="Seat Number /Name"
                      extraClass={`mb-1 w-100 ${
                        formikSeat.errors.seat_number &&
                        formikSeat.touched.seat_number
                          ? "enError"
                          : ""
                      }`}
                      inputType="text"
                      name="seat_number"
                      onChange={formikSeat.handleChange}
                      value={formikSeat.values.seat_number}
                      onFocusOut={formikSeat.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    {formikSeat.errors.seat_number &&
                    formikSeat.touched.seat_number ? (
                      <div className="pho_14_regular text-danger mb-2">
                        {formikSeat.errors.seat_number}
                      </div>
                    ) : (
                      <div className="mb-2"></div>
                    )}
                  </Col>
                  {/* <Col md={6}>
                <NewInputText
                  labelText="Table Capacity"
                  extraClass="mb-3 w-100"
                />
                <span className="f14-400 opacity5 enPositionRightTop">pax</span>
              </Col> */}
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100 mb-3"}>
                      <InputLabel htmlFor="outlined-tableShape">
                        Table Shape
                      </InputLabel>
                      <Select
                        disabled
                        value={formikSeat.values.shape}
                        //onChange={selecthandleChange}
                        //onChange={onChangeTableShape}
                        name
                        label="Table Shape"
                        inputProps={{
                          name: "shape",
                          id: "outlined-tableShape",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"Square"}>Square &#9744;</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col md={6} className="mb-3">
                    <FormControl variant="outlined" className={"w-100 mb-0"}>
                      <InputLabel htmlFor="outlined-tableCapacity">
                        Table Capacity
                      </InputLabel>
                      <Select
                        disabled
                        //value={state.tableCapacity}
                        value={formikSeat.values.pax_value}
                        // onChange={formikSeat.handleChange}
                        label="Table Capacity"
                        inputProps={{
                          name: "pax_value",
                          id: "outlined-tableCapacity",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={1}>1</MenuItem>
                      </Select>
                    </FormControl>
                    <div className="f10-400 opacity5">Total PAX</div>
                    {formikSeat.errors.pax_value &&
                    formikSeat.touched.pax_value ? (
                      <div className="pho_14_regular text-danger">
                        {formikSeat.errors.pax_value}
                      </div>
                    ) : null}
                  </Col>

                  <Col md={6}>
                    <div className="d-flex">
                      <div className="custom">
                        <div className="f10-400 pb-2 opacity5">
                          Temporary Seat
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikSeat.values.temporay}
                          onChange={() => onChangeSeatTemporary()}
                          className={"mx-1"}
                        />
                      </div>
                      <div className="pl-3 custom">
                        <div className="f10-400 pb-2 opacity5">
                          Active/ Inactive
                        </div>
                        <ToggleButtonWithYesNo
                          checkedBox={formikSeat.values.active}
                          onChange={() => onChangeSeatActiveInActive()}
                          className={"mx-1"}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f12-400">Select Table Location</div>
                    <div className="f10-400 opacity5 pb-3">
                      (Locations are based on the seating areas you have
                      selected in seating subscription)
                    </div>
                  </Col>
                  {tableLocation.map((item, index) => (
                    <Col md={4} key={index}>
                      <div className="enCheckWithText w-100">
                        <input
                          type="radio"
                          name="SeatingPreference"
                          checked={formikSeat.values.location === item.title}
                          onChange={() => onChangeSelectSeat(item.title)}
                        />
                        <label
                          className="w-100 d-flex align-items-center p-2"
                          style={{ fontSize: 11 }}
                        >
                          <Image
                            src={item.icon}
                            alt={item.title}
                            title={item.title}
                            className="mr-2"
                            style={{ width: "20%" }}
                          />
                          {item.title}
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
                {formikSeat.errors.location && formikSeat.touched.location ? (
                  <div className="pho_14_regular text-danger">
                    {formikSeat.errors.location}
                  </div>
                ) : null}
                <Row className="align-items-center py-3">
                  <Col md={6}>
                    <div className="f12-400">Seat Status</div>
                  </Col>
                  <Col md={6}>
                    <FormControl variant="outlined" className={"w-100"}>
                      <Select
                        //value={state.tableStatus}
                        value={formikSeat.values.status}
                        disabled={!formikSeat.values.active}
                        //onChange={selecthandleChange}
                        onChange={formikSeat.handleChange}
                        inputProps={{
                          name: "status",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value={"AVAILABLE"}>Available</MenuItem>
                        <MenuItem value={"UNAVAILABLE"}>Unavailable</MenuItem>
                        <MenuItem value={"OCCUPIED"}>Occupied</MenuItem>
                        <MenuItem value={"DIRTY"}>Dirty</MenuItem>
                        <MenuItem value={"ON_HOLD"}>On Hold</MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                {!editSeat ? (
                  <Row className="align-items-center py-3">
                    <Col md={6}>
                      <div className="f12-400">How many Seats to Create?</div>
                    </Col>
                    <Col md={6}>
                      <Row>
                        <Col>
                          <NewInputText
                            extraClass={`m-1 w-100 ${
                              formikSeat.errors.number &&
                              formikSeat.touched.number
                                ? "enError"
                                : ""
                            }`}
                            inputType="number"
                            onInput={maxLengthCheck}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            maxLength={2}
                            name="number"
                            onChange={formikSeat.handleChange}
                            value={formikSeat.values.number}
                            onFocusOut={formikSeat.handleBlur}
                            // isInvalid={
                            //   formik.errors.bankName && formik.touched.bankName
                            // }
                          />
                          {formikSeat.errors.number &&
                          formikSeat.touched.number ? (
                            <div className="pho_14_regular text-danger">
                              {formikSeat.errors.number}
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <> </>
                )}
                <div className="d-flex justify-content-center align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseCreateSeat}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    type="button"
                    onClick={() => onCLickAddNewSeat()}
                    className="btn150px btn-lg px-5"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal show={deleteTable} onHide={handleCloseDeleteTable} centered>
            <Modal.Header className="py-0 pt-2 border-0" closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="f16-500">
              Are you sure to delete this table ?
            </Modal.Body>
            <Modal.Footer className="justify-content-start border-0">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={handleCloseDeleteTable}
              >
                No
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                onClick={onClickYesDeleteTable}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={deleteSeat} onHide={handleCloseDeleteSeat} centered>
            <Modal.Header className="py-0 pt-2 border-0" closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="f16-500">
              Are you sure to delete this seat ?
            </Modal.Body>
            <Modal.Footer className="justify-content-start border-0">
              <Button
                variant="outline-secondary"
                className="btn-lg mr-4 px-5"
                onClick={handleCloseDeleteSeat}
              >
                No
              </Button>
              <Button
                variant="danger"
                className="btn-lg px-5"
                onClick={onClickYesDeleteSeat}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

OfflineEventTableSeatManagement.propTypes = {
  auth: PropTypes.object.isRequired,
  update_new_subscription_for_vendor: PropTypes.func.isRequired,
  update_new_subscription_for_vendor_table_management:
    PropTypes.func.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  seating_area: state?.category?.seating_area,
  allSubscriptionData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  subscriptionData:
    state?.onboarding &&
    state?.onboarding?.onboard_subscription_details &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ?.ordering &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ?.ordering?.home_delivery,
  onboarding: state?.onboarding?.restaurantDetails,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  update_new_subscription_for_vendor_table_management,
})(withRouter(OfflineEventTableSeatManagement));
